import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import enTranslations from "./locales/en.json";
import trTranslations from "./locales/tr.json";
import deTranslations from "./locales/de.json";
import frTranslations from "./locales/fr.json";
import esTranslations from "./locales/es.json";

import { applyTenantOverride, defaultOverrideLoader } from "./loadTenantOverride";
import { getCurrentTenant } from "../config/tenantConfig";

const baseResources = {
  en: { translation: enTranslations },
  tr: { translation: trTranslations },
  de: { translation: deTranslations },
  fr: { translation: frTranslations },
  es: { translation: esTranslations },
};

const tenant = getCurrentTenant();
const resources = applyTenantOverride(
  baseResources,
  tenant.localeOverride,
  defaultOverrideLoader
);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "tr",
    load: "languageOnly",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["querystring", "localStorage", "navigator"],
      lookupLocalStorage: "i18nextLng",
      lookupQuerystring: "lng",
      caches: ["localStorage"],
    },
  });

export default i18n;
